// src/components/Loader.tsx
import React, { FC } from 'react';

const Loader: FC = () => (
  <div className='flex items-center justify-center w-full h-full rounded-[24px] bg-white'>
    <img
      src='/assets/funizzle-logo-zip-file/png/logo-no-background.png'
      alt='Logo'
      className='w-36 h-autopulse'
    />
  </div>
);

export default Loader;
